import React from 'react'
import { flowRight } from 'lodash'
import { connect } from 'react-redux'
import { getClientSelects } from 'src/store/client'
import withCallAPI from 'loankeeper-common/containers/withCallAPI'

const container = flowRight(
  connect(undefined, (dispatch) => ({
    getClientSelects: () => dispatch(getClientSelects()),
  })),
  // withCallAPI({
  //   APICall: [Client.getSelects],
  //   APIParams: [],
  //   transformData: [(response) => {
  //     return ({ clientSelects: response.Data })
  //   }],
  //   withLoading: true,
  // })
  //UPDATED API REQUEST client_lookups_api
  (Component) => {
    const WrappedReqFields = (props) => {
      const { getClientSelects } = props
      const NewComp = React.useMemo(() => {
        const Wrapper = withCallAPI({
          APICall: [
            () => {
              return getClientSelects()
            },
          ],
          APIParams: [],
          transformData: [
            ({ payload }) => {
              return { clientSelects: payload }
            },
          ],
          withLoading: true,
        })(Component)

        return <Wrapper {...props} />
      }, [getClientSelects])

      return NewComp
    }

    return WrappedReqFields
  },
)

export default container
